import React from "react"

import { Input } from "@coval/ui"

import type { MetricRecordData } from "@/types/metrics/contracts"

import {
  FIELD_CONTAINER_STYLES,
  LABEL_ROW_STYLES,
  LABEL_STYLES,
} from "../styles"
import { RequiredMarker } from "./RequiredMarker"

interface MetadataFieldConfigProps {
  metricRecordData: MetricRecordData
  onChange: (metric: MetricRecordData) => void
}

export const MetadataFieldConfig: React.FC<MetadataFieldConfigProps> = ({
  metricRecordData,
  onChange,
}) => {
  const handleFieldKeyChange = (value: string) => {
    onChange({
      ...metricRecordData,
      metric_metadata: {
        ...metricRecordData.metric_metadata,
        metadata_field_key: value,
      },
    })
  }

  return (
    <div className={FIELD_CONTAINER_STYLES}>
      <div className={LABEL_ROW_STYLES}>
        <label className={LABEL_STYLES}>
          Field Key
          <RequiredMarker />
        </label>
      </div>
      <Input
        aria-label="Field Key"
        value={metricRecordData.metric_metadata?.metadata_field_key || ""}
        onChange={(e) => handleFieldKeyChange(e.target.value)}
        placeholder="The key to extract from metadata (e.g., duration, score)"
      />
    </div>
  )
}
